/**
 * Build the user-facing share URL for an announcement.
 *
 * Returns a clean, branded production URL (say-it-now.app/a/{slug}).
 * Social-media crawlers that need OG meta tags are handled separately
 * via getOgShareUrl() which routes through the edge function.
 */

const PRODUCTION_ORIGIN = 'https://say-it-now.app';

function getSiteOrigin(): string {
  if (typeof window !== 'undefined') return window.location.origin;
  return PRODUCTION_ORIGIN;
}

/** Clean, branded URL for SMS, copy-link, and direct sharing. */
export function getAnnouncementShareUrl(publicSlug: string): string {
  const origin = getSiteOrigin();
  return `${origin}/a/${encodeURIComponent(publicSlug)}`;
}

/** OG-safe URL for social platform share buttons (crawlers need meta tags). */
export function getOgShareUrl(publicSlug: string): string {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  if (!supabaseUrl) {
    return getAnnouncementShareUrl(publicSlug);
  }
  return `${supabaseUrl}/functions/v1/og-announcement?slug=${encodeURIComponent(publicSlug)}`;
}
